import { render, staticRenderFns } from "./CoinDogHeader.vue?vue&type=template&id=00b00f98&scoped=true"
import script from "./CoinDogHeader.vue?vue&type=script&lang=js"
export * from "./CoinDogHeader.vue?vue&type=script&lang=js"
import style0 from "./CoinDogHeader.vue?vue&type=style&index=0&id=00b00f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b00f98",
  null
  
)

export default component.exports